import {
  AddOutlined,
  RemoveOutlined,
  ShoppingCart,
  ShoppingCartOutlined,
} from "@mui/icons-material";
import { Button, IconButton, Stack, Divider} from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { useHistory } from "react-router-dom";
import "./Cart.css";

// Definition of Data Structures used
/**
 * @typedef {Object} Product - Data on product available to buy
 * 
 * @property {string} name - The name or title of the product
 * @property {string} category - The category that the product belongs to
 * @property {number} cost - The price to buy the product
 * @property {number} rating - The aggregate rating of the product (integer out of five)
 * @property {string} image - Contains URL for the product image
 * @property {string} _id - Unique ID for the product
 */

/**
 * @typedef {Object} CartItem -  - Data on product added to cart
 * 
 * @property {string} name - The name or title of the product in cart
 * @property {string} qty - The quantity of product added to cart
 * @property {string} category - The category that the product belongs to
 * @property {number} cost - The price to buy the product
 * @property {number} rating - The aggregate rating of the product (integer out of five)
 * @property {string} image - Contains URL for the product image
 * @property {string} productId - Unique ID for the product
 */

/**
 * Returns the complete data on all products in cartData by searching in productsData
 *
 * @param { Array.<{ productId: String, qty: Number }> } cartData
 *    Array of objects with productId and quantity of products in cart
 * 
 * @param { Array.<Product> } productsData
 *    Array of objects with complete data on all available products
 *
 * @returns { Array.<CartItem> }
 *    Array of objects with complete data on products in cart
 *
 */
export const generateCartItemsFrom = async (cartData, productsData) => {

    if(!cartData) return;
  //  console.log("cartqtyid data in generateCartItemsFrom in cart.js", cartData);
   // console.log("product data in generateCartItemsFrom in cart.js", productsData);
    
    const cartItems = cartData.map((cartItem) =>( {
      ...cartItem, ...productsData.find((product)=> (cartItem.productId === product._id))
    }));

    console.log("usercartitems in cartItems in generateCartItemsFrom in cart.js", cartItems);
    return cartItems;
};

/**
 * Get the total value of all products added to the cart
 *
 * @param { Array.<CartItem> } items
 *    Array of objects with complete data on products added to the cart
 *
 * @returns { Number }
 *    Value of all items in the cart
 *
 */
export const getTotalCartValue = (items = []) => {
 const carttotalvalue = items.reduce((totalcost, currProduct)=>{
      return totalcost += currProduct.cost*currProduct.qty;
  }, 0); 
  return carttotalvalue;
};

export const getTotalItems = (items=[])=>{
  let qty = 0;
  // items.reduce(()=)
}


/**
 * Component to display the current quantity for a product and + and - buttons to update product quantity on cart
 * 
 * @param {Number} value
 *    Current quantity of product in cart
 * 
 * @param {Function} handleAdd
 *    Handler function which adds 1 more of a product to cart
 * 
 * @param {Function} handleDelete
 *    Handler function which reduces the quantity of a product in cart by 1
 * 
 * @param {Boolean} isReadOnly
 *    If product quantity on cart is to be displayed as read only without the + - options to change quantity
 * 
 */
const ItemQuantity = ({
  value,
  handleAdd,
  handleDelete,
}) => {
  return (
    <Stack direction="row" alignItems="center">
      <IconButton size="small" color="primary" onClick={handleDelete}>
        <RemoveOutlined />
      </IconButton>
      <Box padding="0.5rem" data-testid="item-qty">
        {value}
      </Box>
      <IconButton size="small" color="primary" onClick={handleAdd}>
        <AddOutlined />
      </IconButton>
    </Stack>
  );
};

/**
 * Component to display the Cart view
 * 
 * @param { Array.<Product> } products
 *    Array of objects with complete data of all available products
 * 
 * @param { Array.<Product> } items
 *    Array of objects with complete data on products in cart
 * 
 * @param {Function} handleDelete
 *    Current quantity of product in cart
 * 
 * @param {Boolean} isReadOnly
 *    If product quantity on cart is to be displayed as read only without the + - options to change quantity
 * 
 */
const Cart = ({
  products,
  items = [],
  handleQuantity,
  isReadOnly = false
}) => {

  const token = localStorage.getItem("token");
  let history = useHistory();
  if (!items.length) {
    return (
      <Box className="cart empty">
        <ShoppingCartOutlined className="empty-cart-icon" />
        <Box color="#aaa" textAlign="center">
          Cart is empty. Add more items to the cart to checkout.
        </Box>
      </Box>
    );
  }
  console.log("cart items",items.length);
  
 return (
    <>
      <Box className="cart">  
     {
      
      items.map((cartProductInfo)=>     
      (cartProductInfo.qty>0? 
(<Box display="flex" alignItems="flex-start" padding="1rem">
    <Box className="image-container">
        <img
            // Add product image
            src={cartProductInfo.image}
            // Add product name as alt eext
            alt={cartProductInfo.name}
            width="100%"
            height="100%"
        />
    </Box>
    <Box
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        height="6rem"
        paddingX="1rem"
    > 
    <Box>
    <div>{cartProductInfo.name}</div>
    </Box>
       
        <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
        >
          {isReadOnly? 
          <Box  display="flex"
          justifyContent="space-between"
          alignItems="center">
          <div>Qty:</div>
          <div> {cartProductInfo.qty}</div></Box>:          
        <ItemQuantity
        value={cartProductInfo.qty}
        handleAdd={async ()=>{
          await handleQuantity(token, items, products, cartProductInfo.productId, cartProductInfo.qty+1);
        }}
        handleDelete={async ()=>{
          await handleQuantity(token, items, products, cartProductInfo.productId, cartProductInfo.qty-1);
        }}
                // Add required props by checking implementation
        />}
        <Box padding="0.5rem" fontWeight="700">
            ${cartProductInfo.cost}
        </Box>
        </Box>
    </Box>
</Box>): null))      
     }
      

        {/* TODO: CRIO_TASK_MODULE_CART - Display view for each cart item with non-zero quantity */}
        <Box
          padding="1rem"
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box color="#3C3C3C" alignSelf="center">
            Order total
          </Box>


          <Box
            color="#3C3C3C"
            fontWeight="700"
            fontSize="1.5rem"
            alignSelf="center"
            data-testid="cart-total"
          >
            ${getTotalCartValue(items)}
          </Box>
        </Box> 
        <Divider />       
      </Box>
      {!isReadOnly? 
      (<Box display="flex" justifyContent="flex-end" className="cart-footer">
        {/* { window.location.pathname==="/checkout"?<></>: */}
          <Button
            color="primary"
            variant="contained"
            startIcon={<ShoppingCart />}
            className="checkout-btn"
            onClick={(e)=>{
              history.push('/checkout');
            }
          }
          >
            Checkout
          </Button>
        {/* } */}
        </Box>):
        (<Box padding={2} className="cart">
          <h4>Order Details</h4>
          <Box display="flex"
          justifyContent="space-between"
          alignItems="center"
          >
            <Box color="#3c3c3c" alignSelf="center">Products</Box>
            <Box color="#3c3c3c" alignSelf="center">{items.length}</Box>
          </Box>
          <Box display="flex"
          justifyContent="space-between"
          alignItems="center"
          paddingBottom={2}
          >
            <Box color="#3c3c3c" alignSelf="center">Subtotal</Box>
            <Box color="#3c3c3c" alignSelf="center">${getTotalCartValue(items)}</Box>
          </Box>

          <Box display="flex"
          justifyContent="space-between"
          alignItems="center"
          paddingBottom={2}
          >
            <Box color="#3c3c3c" alignSelf="center">Shipping Charges</Box>
            <Box color="#3c3c3c" alignSelf="center">$0</Box>
          </Box>
          <Box display="flex"
          justifyContent="space-between"
          alignItems="center"
          paddingBottom={2}
          >
            <Box color="#3c3c3c" alignSelf="center">Total</Box>
            <Box color="#3c3c3c" alignSelf="center">${getTotalCartValue(items)}</Box>
          </Box>
        </Box>)
        }
    </>
  );
};

export default Cart;
